import createContext from 'zustand/context';
import shallow from 'zustand/shallow';
const {
  Provider,
  useStore,
  useStoreApi
} = createContext();
/**
 * Same as useStore but with built-in shallow object/array comparison. Use this hook
 * if you want to construct a single object/array with multiple state-picks inside,
 * similar to redux's mapStateToProps.
 * @see https://github.com/pmndrs/zustand#selecting-multiple-state-slices
 */

const useShallowStore = selector => useStore(selector, shallow);
/**
 * A convenience method that returns the actions from the store.
 * It's configured in eslint to be static, so the actions don't need
 * to be added to the dependency array in hooks that use them.
 */


const useStoreActions = () => useStore(actionsSelector);

const actionsSelector = state => state.actions;

export { useStore, useStoreApi, useShallowStore, useStoreActions, Provider };